var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [_vm._t("default")], 2)
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js?{"esModule":true,"extractCSS":false}!./node_modules/vue-loader/lib?{"esModule":true,"extractCSS":false}!./ClientApp/calendar/layout.vue?vue&type=template&id=4ad206a4&
// module id = 331
// module chunks = 2